import React, { Component } from 'react';

import PropTypes from 'prop-types';

import CanvasMenuButton from '../menu/CanvasMenuButton';
import CanvasMenuDropDown from '../menu/CanvasMenuDropDown';

import './CanvasAlign.scss';

export default class CanvasAlign extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    updateInfo: PropTypes.func
  };

  align(method) {
    const { canvasRef } = this.props;

    const activeObjects = canvasRef.getActiveObjects();

    activeObjects.forEach((object) => {
      canvasRef.setActiveObject(object);
      method(object, canvasRef);
      object.setCoords();
    });

    canvasRef.discardActiveObject();
    canvasRef.renderAll();
  }

  alignCenter() {
    this.align((object) => object.centerH());
    this.props.updateInfo();
  }

  alignLeft() {
    this.align((object) => object.set({ left: 0 }));
    this.props.updateInfo();
  }

  alignRight() {
    this.align((object, canvas) =>
      object.set({ left: canvas.getWidth() - object.width * object.scaleX })
    );
    this.props.updateInfo();
  }

  render() {
    const labelPrefix = 'canvas-editor.align-objects.horizontal';

    return (
      <div className="align-menu">
        <CanvasMenuDropDown
          className="text-menu__button--large"
          icon="obj-align-center-default"
          toolTip="canvas-editor.text.align"
        >
          <CanvasMenuButton
            className="text-menu__button--large"
            onClick={() => this.alignLeft()}
            toolTip={`${labelPrefix}.left`}
            icon="obj-align-left"
            label={`${labelPrefix}.left`}
          />

          <CanvasMenuButton
            className="text-menu__button--large"
            onClick={() => this.alignCenter()}
            toolTip={`${labelPrefix}.center`}
            icon="obj-align-center"
            label={`${labelPrefix}.center`}
          />

          <CanvasMenuButton
            className="text-menu__button--large"
            onClick={() => this.alignRight()}
            toolTip={`${labelPrefix}.right`}
            icon="obj-align-right"
            label={`${labelPrefix}.right`}
          />
        </CanvasMenuDropDown>
      </div>
    );
  }
}
